import Button from 'Components/Atoms/Button/Button';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SuggestionButton(props) {
    const { title, descriptionItems, onClick, actionText, className } = props;

    if (!title) {
        return null;
    }

    return (
        <div
            className={cn(
                'border-warning ring-2 max-w-[172px] w-fit ring-warning/20 p-2.5 relative rounded-md border',
                className,
            )}
        >
            <div className="text-dark-blue text-sm mb-0.25 leading-tight">{title}</div>
            <div className="text-xs text-gray-500 mb-2.5">
                {descriptionItems.map((item, index) => (
                    <div key={index} className="text-pretty">
                        {item}
                    </div>
                ))}
            </div>

            <Button size="small" className="w-full" variant="tertiary" onClick={onClick}>
                {actionText}
            </Button>
        </div>
    );
}

SuggestionButton.propTypes = {
    title: PropTypes.string,
    descriptionItems: PropTypes.arrayOf(PropTypes.string).isRequired,
    onClick: PropTypes.func.isRequired,
    actionText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    className: PropTypes.string,
};
